<template>
  <div class="car-series fill-section-1080">
    <div class="car-series-content fade-up">
      <img class="car-series-logo" :src="carSeriesObj.logo" :alt="carSeriesObj.series">
      <p class="car-series-desc">{{ carSeriesObj.desc }}</p>
      <p class="car-series-title" v-html="carSeriesObj.title"></p>
    </div>
    <div class="car-series-list">
      <div class="car-series-item" v-for="(item, index) in carSeriesObj.carList" :key="index">
        <img class="img-cover" :src="item.img" :alt="item.tag" />
        <div class="car-series-item-wrap fade-up">
          <p class="car-series-item-series">{{ carSeriesObj.series }}</p>
          <i class="car-series-item-line"></i>
          <p class="car-series-item-name">{{ item.name }}</p>
          <button class="car-series-item-link" target="_blank" @click="toCarDetail(item.link)">了解详情 →</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  name: 'CarSeriesComponents',
  props: {
    carSeriesObj: {
      type: Object,
      required: true
    },
  },
  mounted() {
    fadeAnimate();
  },
  beforeDestroy() {
    destroyFadeAnimate();
  },
  data() {
    return {

    }
  },
  methods: {
    toCarDetail(link) {
      if (!link) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return;
      }
      this.$router.push({ name: link })
    }
  },
}
</script>

<style lang="less" scoped>
.car-series {
  width: 100%;
  background-color: #E6E8E7;
  padding: 4.17vw 3.42vw 2.44vw;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  .car-series-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .car-series-logo {
      width: clamp(300px, 21.46vw, 412px);
      height: auto;
    }
    .car-series-desc {
      font-size: clamp(16px, 1.25vw, 24px);
      font-weight: @fw2;
      color: #666666;
    }
    .car-series-title {
      font-size: clamp(32px, 2.5vw, 48px);
      font-weight: @fw1;
      color: #222222;
    }
  }
  .car-series-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 30px;
    .car-series-item {
      flex: 1;
      position: relative;
      .car-series-item-wrap {
        position: absolute;
        left: 2.08vw;
        bottom: 3.33vw;
        font-weight: @fw2;
        display: flex;
        flex-direction: column;
        .car-series-item-series {
          color: #646460;
          font-size: 12px;
          letter-spacing: 4px;
        }
        .car-series-item-line {
          width: 32px;
          height: 1px;
          border-bottom: 1px solid rgba(5, 5, 5, 0.34);
          margin: 16px 0;
        }
        .car-series-item-name {
          font-size: clamp(16px, 1.25vw, 24px);
          color: #000000;
        }
        .car-series-item-link {
          margin-top: 16px;

          font-size: clamp(12px, 0.83vw, 16px);

          color: #222222;

          border: 1px solid rgba(0, 0, 0, 0.2);

          width: 126px;

          height: 38px;

          padding: 0;

          display: inline-flex;

          align-items: center;

          justify-content: center;

          background: transparent;

          box-sizing: border-box;

          white-space: nowrap;
        }

      }
    }

  }
}
@media (max-width: @mobile-width) {
  .car-series {
    padding: 0;
    .car-series-content {
      margin-top: 16vw;
      .car-series-logo {
        width: 56vw;
        height: auto;
      }
      .car-series-desc {
        font-size: 4.26vw;
        margin-top: 2.67vw;
      }
      .car-series-title {
        margin-top: 1.6vw;
        font-size: 8.53vw;
        text-align: center;
        line-height: 1.2;
      }
    }
    .car-series-list {
      margin-top: 7vw;
      margin-left: 5.33vw;
      margin-bottom: 10.67vw;
      justify-content: start;
      column-gap: 3.2vw;
      flex-wrap: nowrap;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      &::-webkit-scrollbar { display: none; }
      .car-series-item {
        flex: none;
        width: 74.67vw;
        height: 81.6vw;
        .car-series-item-wrap {
          left: 4.26vw;
          bottom: 2.67vw;
          .car-series-item-series { font-size: 2.67vw;}
          .car-series-item-line { width: 3.47vw; margin: 1.61vw 0; }
          .car-series-item-name { font-size: 4.26vw; }
          .car-series-item-link {  font-size: 2.67vw; margin-top: 1.61vw; width: 26vw; height: 8vw; padding: 0; display: inline-flex;  align-items: center;  justify-content: center; box-sizing: border-box; white-space: nowrap;}
        }
      }
    }
  }
}
</style>